module.exports = __webpack_public_path__ + "img/magento-support-security.c7577cfe.jpeg";